import { COLORPLAN } from "../components/ColorplanSwatches";

// Curated Colorplan pairings per foil family — the combinations our stationers reach for first.
const CURATED = {
  metallized: ["Ebony", "Imperial Blue", "Racing Green", "Natural"],
  holographic: ["Ebony", "Bright White", "Imperial Blue", "Dark Grey"],
  "holographic-specialty": ["Ebony", "Claret", "Sapphire", "Pristine White"],
  "matte-pigments": ["Ebony", "Nubuck Brown", "Mist", "Forest"],
  "gloss-pigments": ["Bright White", "Ebony", "Stone", "Dark Grey"],
};

const rgb = (hex) => { const n = parseInt(hex.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; };
const lum = (hex) => { const [r, g, b] = rgb(hex).map((v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; }); return 0.2126 * r + 0.7152 * g + 0.0722 * b; };
export const contrastRatio = (a, b) => { const [l1, l2] = [lum(a), lum(b)].sort((x, y) => y - x); return (l1 + 0.05) / (l2 + 0.05); };
export const isLightHex = (hex) => lum(hex) > 0.4;

// 3–4 curated papers for the family + the 2 highest-contrast Colorplan shades for this exact foil.
export function pairingsFor(foil) {
  const curated = (CURATED[foil.family] || CURATED.metallized).map((name) => COLORPLAN.find(([n]) => n === name)).filter(Boolean).map(([name, hex]) => ({ name, hex, why: "Our pick", contrast: contrastRatio(foil.hex, hex) }));
  const taken = new Set(curated.map((c) => c.name));
  const auto = COLORPLAN.filter(([n]) => !taken.has(n)).map(([name, hex]) => ({ name, hex, why: "Contrast pick", contrast: contrastRatio(foil.hex, hex) })).sort((a, b) => b.contrast - a.contrast).slice(0, 2);
  return [...curated, ...auto];
}
